import { UI } from '@prz-dp/ui';
import { PKAgLazyTable, PKAgTable } from '@prz-dp/ui/pk-grid';
import Vue from 'vue';

Vue.use(UI, {
  components: { PKAgLazyTable: PKAgLazyTable, PKAgTable: PKAgTable },
  vuetifyVersion: 2
});
